var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"adverts_detail_container"},[(_vm.detail)?_c('div',{staticClass:"adverts_detail_box"},[_c('div',{staticClass:"title",domProps:{"textContent":_vm._s(_vm.detail.title)}}),(_vm.detail.type==2)?_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.detail.resultContent)}}):_vm._e()]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }